/**
 * Per-page change accumulator used by paginated /sync/pull.
 *
 * Extracted from sync/index.ts so it can be unit-tested without booting
 * WatermelonDB, the auth store, or the network layer. Pure function — no
 * I/O, no side effects beyond mutating `target` in place.
 *
 * Invariant the tests defend: if any page's records are dropped here,
 * the device's local DB will end up missing rows that the server returned.
 * That's a silent data-loss path.
 */

export interface SyncTableChanges {
    created: Record<string, unknown>[];
    updated: Record<string, unknown>[];
    deleted: string[];
}

export function mergeChanges(
    target: Record<string, SyncTableChanges>,
    page: Record<string, SyncTableChanges>,
): void {
    for (const [table, tableChanges] of Object.entries(page)) {
        if (!target[table]) {
            target[table] = { created: [], updated: [], deleted: [] };
        }
        if (tableChanges.created?.length) target[table].created.push(...tableChanges.created);
        if (tableChanges.updated?.length) target[table].updated.push(...tableChanges.updated);
        if (tableChanges.deleted?.length) target[table].deleted.push(...tableChanges.deleted);
    }
}
